import { c as _c } from "react/compiler-runtime";
import { FormInput } from '@systemeio/ui';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { useUpdateXenditIntegration } from 'modules/profile/payment-gateways/integrations/xendit/hooks';
import { XenditIntegrationErrorsInterface, XenditUpdateIntegrationInterface } from 'modules/profile/payment-gateways/integrations/xendit/types';
import React, { useState } from 'react';
import EditModal from 'shared/components/edit-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
interface XenditEditModalProps {
  details: XenditUpdateIntegrationInterface;
}
const defaultErrors: XenditIntegrationErrorsInterface = {
  organizationName: '',
  webhookSecret: '',
  secretAccessToken: '',
  publicAccessToken: ''
};
const XenditEditModal = t0 => {
  const $ = _c(33);
  const {
    details
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    updateXenditIntegration
  } = useUpdateXenditIntegration();
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t1;
  if ($[0] !== mutatePaymentIntegrations || $[1] !== updateXenditIntegration) {
    t1 = async data => {
      await fetchWithErrors(async () => {
        await updateXenditIntegration(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = updateXenditIntegration;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onEdit = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpened(true);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("global.settings");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <button className="primary-link flex justify-start" onClick={t2}>{t3}</button>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("global.edit");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("dashboard.settings.payment-gateways.xendit_integration").toLowerCase();
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `${t5} ${t6} `;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setOpened(false);
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== errors || $[14] !== t) {
    t9 = {
      field: "organizationName",
      onRender: (value, onChange) => <FormInput key="xendit-organization-name-edit" label={t("dashboard.settings.payment-gateways.organization_name")} value={value} onChange={e => onChange(e.target.value)} required={true} error={errors.organizationName} />
    };
    $[13] = errors;
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== errors || $[17] !== t) {
    t10 = {
      field: "webhookSecret",
      onRender: (value_0, onChange_0) => <FormInput key="xendit-webhook-secret-edit" label={t("dashboard.settings.payment-gateways.webhook_secret")} value={value_0} onChange={e_0 => onChange_0(e_0.target.value)} required={true} error={errors.webhookSecret} />
    };
    $[16] = errors;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = [t9, t10];
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== onEdit) {
    t12 = data_0 => onEdit(data_0);
    $[22] = onEdit;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== details || $[25] !== opened || $[26] !== t11 || $[27] !== t12 || $[28] !== t7) {
    t13 = <EditModal fullCaption={t7} opened={opened} onClose={t8} instance={details} editable={t11} onEdit={t12} />;
    $[24] = details;
    $[25] = opened;
    $[26] = t11;
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t4) {
    t14 = <>{t4}{t13}</>;
    $[30] = t13;
    $[31] = t4;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default XenditEditModal;